module.exports = __webpack_public_path__ + "img/open_path_square.4a51907f.png";